import script from "./add-agents-free-dev.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-agents-free-dev.vue?vue&type=script&setup=true&lang=ts"

import "./add-agents-free-dev.vue?vue&type=style&index=0&id=1be2c7c5&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be2c7c5"]])

export default __exports__